import { makeHTTPProvider } from 'shared/infra/providers';

/**
 * Valida o cupom no Vectis.
 *
 * Sem unidade, quem resolve e o backend pelo pais da requisicao. Antes o site caia em 40,
 * a unidade virtual do e-commerce brasileiro, em qualquer pais.
 */
const fetchCoupon = async (cupom, unidade, produtos, pacotes) => {
  const unidadeParam = unidade ? `unidade=${unidade}&` : '';
  const pacotesParam = pacotes ? `&pacotes=${pacotes}` : '';
  const url = `/coupon/${cupom}?${unidadeParam}produtos=${produtos}${pacotesParam}`;

  return makeHTTPProvider()
    .get(url)
    .then(data => {
      if (!data) return null;

      return {
        id: data.id,
        codigo: data.codigoCupom,
        dataCriacao: data.dataCriacao,
        valorDesconto: data.valor,
        percentualDesconto: data.percentual,
      };
    });
};

export default fetchCoupon;
